import React, { FunctionComponent } from 'react'

import styled, { keyframes, useTheme } from 'styled-components'

import SvgIcon from '@components/SvgIcon'

const LOADER_SIZE = '24px'
const ANIMATION_DURATION = '1s'

const AnimatedStarsWrapper = styled.div`
  display: 'flex';
  gap: 16;
  align-items: 'center';
  width: ${LOADER_SIZE};
  height: ${LOADER_SIZE};
  position: relative;
`

const star1Scale = keyframes`
  0% { transform: scale(1.8); }
  50% { transform: scale(1); }
  100% { transform: scale(1.8); }
`

const star2Scale = keyframes`
  0% { transform: scale(0.8); }
  50% { transform: scale(0.5); }
  100% { transform: scale(0.8); }
`

const star3Scale = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.5); }
  100% { transform: scale(1); }
`

const Star1Svg = styled(SvgIcon)`
  width: ${LOADER_SIZE};
  height: ${LOADER_SIZE};
  transform-origin: 18px 9px;
  animation: ${star1Scale} ${ANIMATION_DURATION} linear infinite;

  position: absolute;
  left: 0;
  top: 0;
`

const Star2Svg = styled(SvgIcon)`
  width: 24px;
  height: 24px;
  transform-origin: 12px 17.460372px;
  animation: ${star2Scale} ${ANIMATION_DURATION} linear infinite;

  position: absolute;
  left: 0;
  top: 0;
`

const Star3Svg = styled(SvgIcon)`
  width: ${LOADER_SIZE};
  height: ${LOADER_SIZE};
  transform-origin: 6.5px 6.5px;
  animation: ${star3Scale} ${ANIMATION_DURATION} linear infinite;

  position: absolute;
  left: 0;
  top: 0;
`
const AnimatedStars: FunctionComponent = () => {
  const theme = useTheme()
  return (
    <AnimatedStarsWrapper>
      <Star1Svg
        iconName="ai-loader-star1"
        size={LOADER_SIZE}
        color={theme.colors.iconDefault}
      />
      <Star2Svg
        iconName="ai-loader-star2"
        size={LOADER_SIZE}
        color={theme.colors.iconDefault}
      />
      <Star3Svg
        iconName="ai-loader-star3"
        size={LOADER_SIZE}
        color={theme.colors.iconDefault}
      />
    </AnimatedStarsWrapper>
  )
}

export default AnimatedStars
